import React from 'react';
import './HomeAbout.css';

function HomeAbout() {
    return (
        <div className="about">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>About Us</h1>
                    </div>
                    <div className="col-md-6">
                        <div className="about_text">
                            <div className="text-content">
                                <p>
                                    Welcome to DharManager, where we are passionate about
                                    revolutionizing the world of HR solutions. With 10 years of
                                    experience and expertise, we are dedicated to providing seamless
                                    recruitment and onboarding experiences for businesses of all
                                    sizes.
                                </p>
                                <p>
                                    Our journey began with the vision to simplify the hiring process
                                    and create a positive impact on organizations. Since our
                                    founding, we have achieved numerous milestones and helped
                                    countless clients achieve their recruitment goals.
                                </p>
                                <p>
                                    With a team of industry experts, we bring a wealth of knowledge
                                    and experience to the table. Our certified professionals stay up
                                    to date with the latest trends and best practices in the HR
                                    industry, ensuring that we provide cutting-edge solutions
                                    tailored to your unique needs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 d-flex justify-content-center align-items-center">
                        <div className="about_box">
                            <img src="/images/aboutimg.svg" alt="picture" className="about-image img-fluid" />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="about_text1">
                            <p>
                                We are not just a company - we are a team of passionate
                                individuals who believe in fostering a positive work culture. Our
                                values of integrity, innovation, and excellence guide everything
                                we do, both internally and externally.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 text-center">
                        <div className="button">
                            <button id="read">Read More</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeAbout;
